
import type { Instance } from '@empathybroker/tsclient-play/dist/models/instance/instance'
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import { UiTooltip } from '../keen-ui'

export default defineComponent({
  name: 'InstanceCard',
  components: {
    UiTooltip,
  },
  props: {
    instance: {
      type: Object as PropType<Instance>,
      required: true,
    },
    selected: Boolean,
  },
  data() {
    return {
      logoIsValid: true,
    }
  },
  computed: {
    logoUrl(): string {
      return (!!this.instance.logoUrls && this.instance.logoUrls.imagotype) || ''
    },
    name(): string {
      return this.instance.prettyName || this.instance.id
    },
  },
})
